import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'

import PageItemDatabase from './components/itemdatabase/PageItemDatabase.vue'
import PagePlayers from './components/PagePlayers.vue'
import PageWorldItems from './components/worlditems/PageWorldItems.vue'
import PageServers from './components/PageServers.vue'
import PageAudit from './components/PageAudit.vue'

loadFonts()

const app = createApp(App);

app.use(vuetify)
app.component('page-world-items', PageWorldItems)
app.component('page-players', PagePlayers)
app.component('page-item-database', PageItemDatabase)
app.component('page-servers', PageServers)
app.component('page-audit', PageAudit)

app.mount('#app');
